module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/First_criterium-2c5f73822e159aba0d920064269ac277.svg";